<template>
  <div
    class="triangle-isosceles speechBubble"
    @click.stop="$emit('click')"
  >
    <span
      v-for="item in speechBubbleContent"
      :key="item.benchMark"
      class="bubbleSpan"
      :style="`border-bottom:3px solid ${item.color}`"
    >
      {{ item.benchMark }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    speechBubbleContent: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.triangle-isosceles {
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 15px;
  color: #000;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  margin: 38px 0 0 55px;
  background: var(--metal-white);
  box-shadow: 4px 4px 12px 0px rgba(0, 0, 0, 0.08);
  width: 130px;
  text-align: center;
}
.triangle-isosceles:after {
  content: "";
  position: absolute;
  bottom: -15px; /* value = - border-top-width - border-bottom-width */
  left:50px; /* controls horizontal position */
  border-style: solid;
  display: block;
  width: 0;

  top: 38px; /* controls vertical position */
  left: -30px; /* value = - border-left-width - border-right-width */
  bottom: auto;
  border-width: 15px 40px 1px 0px;
  border-color: transparent var(--metal-white);
}
.speechBubble{
  &:hover{
    transform: scale(1.05);
    transition: 0.3s;
    z-index: 10;
  }
}
.bubbleSpan{
  width: fit-content;
  align-self: center;
  padding: 0 8px;
}
</style>
